import { render, staticRenderFns } from "./v_About.vue?vue&type=template&id=7a2c62d6&scoped=true&"
import script from "./v_About.vue?vue&type=script&lang=js&"
export * from "./v_About.vue?vue&type=script&lang=js&"
import style0 from "./v_About.vue?vue&type=style&index=0&id=7a2c62d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2c62d6",
  null
  
)

export default component.exports